<template>
<div>
   <!-- Single tab Results tab -->
    <div class="row table-wrapper">
        <div class="left-column">
            <!-- Main results table -->
            <vdog-round-result
                class="single-table main-result"
                v-if="roundResult && roundResult.FirstPlace && roundResult.SecondPlace && roundResult.ThirdPlace"
                :roundNo="previousMatch.roundNo"
                :firstPosition="roundResult.FirstPlace"
                :secondPosition="roundResult.SecondPlace"
                :thirdPosition="roundResult.ThirdPlace"
                :match="this.previousMatch"/>

            <!-- Winner & placement bettings -->
            <vdog-winner-placement
                class="single-table wap-bettings"
                :match="this.previousMatch" />

            <vdog-addition-betting
                class="single-table additional-betting"
                :match="this.previousMatch" />
        </div>

        <div class="right-column">
            <!-- Previous results table -->
            <vdog-previous-results
                v-if="this.roundLastTenResult"
                :areLastResultsVisible="parseInt(roundResult && roundResult.FirstPlace && roundResult.SecondPlace && roundResult.ThirdPlace)"
                :matchResults="this.roundLastTenResult"/>

            <!-- Opposite placement bettings -->
            <vdog-opposite-placement
                class="single-table op-bettings"
                :match="this.previousMatch"/>

            <vdog-match-table
                class="single-table combined-table"
                :activeStake="previousMatch.activeStake"
                :title="previousMatch.combinationBettingTable.title"
                :header="previousMatch.combinationBettingTable.header"
                :stakes="previousMatch.combinationBettingTable.data"
                :isBettingEnabled="false"
                :resultTable="true"
                :sideItems="previousMatch.combinationBettingTable.sideItems">
                <div class="bottom-fields">
                        <p>
                            {{$t('vdog_result_message')}}
                        </p>
                    </div>
            </vdog-match-table>
        </div>
    </div>
</div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import VDogRoundResult from '@/components/grayhound/results/VDogRoundResult.vue'
import VDogPreviousResults from '@/components/grayhound/results/VDogPreviousResults.vue'
import VDogWinnerAndPlacementBetting from '@/components/grayhound/results/VDogWinnerAndPlacementBetting.vue'
import VDogAdditionBetting from '@/components/grayhound/results/VDogAdditionBetting.vue'
import VDogOppositePlacementBetting from '@/components/grayhound/results/VDogOppositePlacementBetting.vue'
import VDogMatchTable from '@/components/grayhound/match/VDogMatchTable.vue'

export default {
  components: {
    'vdog-round-result': VDogRoundResult,
    'vdog-match-table': VDogMatchTable,
    'vdog-previous-results': VDogPreviousResults,
    'vdog-winner-placement': VDogWinnerAndPlacementBetting,
    'vdog-addition-betting': VDogAdditionBetting,
    'vdog-opposite-placement': VDogOppositePlacementBetting
  },
  mixins: [NumberFormat],
  props: {
    roundLastTenResult: Array,
    roundResult: {
      type: Object,
      required: true
    },
    previousMatch: {
      type: Object,
      required: true
    }
  },
  methods: {
  }
}
</script>
